module.exports = function getResource(label) {
    let resources = {
        reviews: 'reviews'
    };
    return resources[label];
};
